import { type ReactNode } from "react";
import PennLabel from "../label/PennLabel";
import PennText from "../text/PennText";

type PennFieldProps = {
  label?: string;
  htmlFor?: string;
  required?: boolean;
  error?: string;
  hint?: string;
  className?: string;
  children: ReactNode;
};

export const PennField = ({
  label,
  htmlFor = "",
  required = false,
  error,
  hint,
  className = "",
  children,
}: PennFieldProps) => (
  <div className={className}>
    {label && (
      <div className="flex items-center gap-1 mb-1.5">
        <PennLabel htmlFor={htmlFor} size="sm" color="slate-800" font="medium">
          {label}
        </PennLabel>
        {required && (
          <PennLabel htmlFor={htmlFor} size="sm" color="error" font="medium">
            *
          </PennLabel>
        )}
      </div>
    )}
    {children}
    {error ? (
      <PennText size="xs" color="error" className="mt-1.5">
        {error}
      </PennText>
    ) : hint ? (
      <PennText size="xs" color="slate-500" className="mt-1.5">
        {hint}
      </PennText>
    ) : null}
  </div>
);
